import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.7.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_eslint@7.32.0__cb46d35bd36de2f95fd3d33487beb628/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}